import { getRuntimeEnv } from './env';

const env = getRuntimeEnv();

export const site = {
  name: 'SolarGabay PH',
  tagline: 'Your guide to solar and electricity.',
  description:
    'Independent Philippine solar and electricity calculators, planning guides, installer preparation, and quote-comparison tools.',
  origin: String(env.VITE_SITE_URL || 'https://solargabayph.com').replace(/\/$/, ''),
  contactEmail: 'contact@solargabayph.com',
  operatorName: String(env.VITE_OPERATOR_NAME || 'SolarGabay PH Independent Planning Team'),
  location: String(env.VITE_BUSINESS_LOCATION || 'Philippines · Remote-first'),
  responseTime: String(env.VITE_RESPONSE_TIME || 'Usually within 2 business days'),
  repositoryUrl: String(
    env.VITE_PUBLIC_REPOSITORY_URL || 'https://github.com/sioteyu/solargabayph',
  ),
  facebookUrl: String(env.VITE_FACEBOOK_URL || ''),
  linkedinUrl: String(env.VITE_LINKEDIN_URL || ''),
  buildId: String(env.VITE_BUILD_ID || '2026.08.04-vignette-cooldown-v1.6.20'),
  canonicalHost: 'solargabayph.com',
  secondaryHost: 'www.solargabayph.com',
};
